import store from "@/store";
import {getProductIdForBrand} from "@/config";

export function getProductIdForService(serviceId) {
    const brand = store.state.brandConfig?.brand;
    const resolvedProductId = getProductIdForBrand(brand, serviceId);
    return resolvedProductId
        ?? store.state.productId
        ?? store.state.brandConfig?.productId
        ?? null;
}

export default function getCurrentProductId() {
    return getProductIdForService(store.state.serviceId);
}
